import { styled, Box, Typography } from '@mui/material';

import { CompareCarrierLogoBoxStyled } from '../PlanCard/PlanCardStyled';
import { PremiumTextStyled } from '../PlanCard/PlanDetailsStyled';

export const ComparisonSummaryContainerStyled = styled('div')({
  marginTop: '40px',
  '@media (max-width: 743px)': {
    marginTop: '24px',
  },
});

export const PerPayPeriodStyled = styled(Typography)({
  fontSize: 16,
  fontWeight: 400,
});

export const ComparePlansSummaryStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  background: '#fff',
  position: 'sticky',
  zIndex: 1000,
  transform: 'translateX(-50%)',
  marginLeft: '50%',
  width: '100vw',
  boxShadow: 'var(--elevated-top)',
  '.compared-plans-container': {
    maxWidth: '900px',
    margin: '0 auto',
  },
  '@media (max-width: 743px)': {
    gap: '4vw',
    padding: '5px',
  },
  '.is-pinned & .compare-plan-details': {
    [CompareCarrierLogoBoxStyled]: {
      width: '100%',
      height: '36px',
      border: 'none',
      padding: '0',
    },
    '& .headline-3': {
      fontSize: '1.6rem',
      fontWeight: 400,
    },
    [PremiumTextStyled]: {
      fontSize: '2.3rem',
      fontWeight: 600,
    },
    [PerPayPeriodStyled]: {
      fontSize: '1.4rem',
    },
  },
});

export const ContentDetailsBoxStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: '16px',
  backgroundColor: '#FFFFFF',
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: '6px',
  marginTop: theme.spacing(2.5),
  '& .prices': {
    marginTop: theme.spacing(4),
    '& .MuiTypography-body2': {
      paddingBottom: theme.spacing(1.5),
    },
  },
  '& .equal-width': {
    flex: 1,
    marginLeft: theme.spacing(10),
    '&:first-child': {
      marginLeft: 0,
    },
  },
  '@media (max-width: 743px)': {
    border: 'none',
    display: 'block',
    width: 'auto',
    textAlign: 'left',
    height: 'auto',
    padding: '0',
    margin: '0',
  },
}));

export const ComparisonUnitStyled = styled('div')(({ theme }) => ({
  '@media (max-width: 743px)': {
    padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
    backgroundColor: '#FFFFFF',
    marginLeft: 0,
  },
}));

export const PlanNameStyled = styled('div')({
  textTransform: 'capitalize',
  height: '42px',
  maxHeight: '42px',
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  textOverflow: 'ellipsis',
  '@media (max-width: 1199px)': {
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: 600,
    marginTop: '16px',
    marginBottom: '8px',
  },
  '@media (min-width: 1200px)': {
    fontSize: '19px',
    lineHeight: '26.6px',
    letterSpacing: '.15px',
    marginTop: '8px',
    height: '53px',
    maxHeight: '53px',
    fontWeight: 400,
  },
});

export const KeyDifferencesLabelStyled = styled('span')(({ theme }) => ({
  fontSize: '16px',
  fontWeight: '600',
  color: `${theme.palette.grey[400]}`,
  '@media (max-width: 743px)': {
    fontSize: '14px',
  },
}));

export const KeyDifferencesStyled = styled('div')({
  boxShadow: '0px 1px 10px 0px #0000003D',
});

export const DetailedComparisonLabel = styled('span')(({ theme }) => ({
  '@media (max-width: 743px)': {
    fontSize: '19px',
    fontWeight: '600',
    color: `${theme.palette.primaryDark.main}`,
  },
}));

export const OtherDifferencesLabelStyled = styled('span')(({ theme }) => ({
  '@media (max-width: 743px)': {
    fontSize: '14px',
    fontWeight: '600',
    color: `${theme.palette.grey[500]}`,
  },
}));

export const DetailedComparisonContentStyled = styled('div')({
  '& > div': {
    boxShadow: '0px 0.85px 8.53px 0px #0000003D',
    marginBottom: '24px',
  },
});

export const ContentLabelStyled = styled(Typography)(({ theme }) => ({
  borderBottom: `0.1rem solid ${theme.palette.grey[200]}`,
  paddingBottom: theme.spacing(2.5),
  '@media (max-width: 743px)': {
    backgroundColor: '#F6F8F9',
    borderBottom: '1px solid #E6E6E6',
    borderTop: '1px solid #E6E6E6',
    textAlign: 'center',
    paddingTop: '1rem',
    color: '#55575E',
    fontSize: '14px',
  },
})) as typeof Typography;

export const SliderIconStyled = styled(Box)({
  borderRadius: '6px',
  border: '1px solid #3C548E',
  display: 'none',
  cursor: 'pointer',
  '@media (max-width: 743px)': {
    display: 'block',
  },
});

export const MobileFilterSectionStyled = styled(Box)({
  position: 'fixed',
  bottom: '0',
  left: '0',
  width: '100%',
  zIndex: '1000',
  backgroundColor: '#fff',
  '@media (min-width: 744px)': {
    position: 'absolute',
  },
});

export const MobileFilterHeaderStyled = styled(Box)({
  padding: '24px 24px 0',
  borderBottom: '1px solid #bababa',
  display: 'flex',
  justifyContent: 'space-between',
  '@media (min-width: 744px)': {
    padding: '12px 24px 0',
  },
});

export const DetailedComparisonStyled = styled('div')({
  display: 'flex',
  margin: '32px 0',
  paddingRight: '6px',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
});

export const ComparisonKeysStyled = styled(Box)({
  display: 'flex',
  '@media (max-width: 743px)': {
    flexDirection: 'column',
    marginBottom: '30px',
    marginLeft: '10px',
    '& > *': {
      marginTop: '12px',
    },
  },
});
